<div class="hero-image">
    
</div>
